import script from "./HealthStatisc.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthStatisc.vue?vue&type=script&setup=true&lang=js"

import "./HealthStatisc.vue?vue&type=style&index=0&id=47d8c27d&scoped=true&lang=scss"

import exportComponent from "F:\\hwx\\proj\\vscode\\twzc_system_web\\dataV\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d8c27d"]])

export default __exports__